import React from "react";
import {BrowserView, MobileView} from 'react-device-detect';
import GlobalWPUser from "../models/WPUser";
import WPCalendarEvent from "../models/WPCalendarEvent";
import TableComponent from "../components/TableComponent";
import { Input, Menu, MenuList, MenuItem, MenuButton, IconButton, Spinner, Container, Flex, Card, CardActionArea, CardHeader, CardContent, CardActions, Chip} from "@airbus/components-react";
import { MoreHoriz, Delete, Edit, Visibility } from "@airbus/icons/react";
import EventEditForm from "../forms/EventEditForm";
import eventBus from "../eventBus/EventBus";
import EventInfoView from "./EventInfoView";
import ModalMessageBox from "../components/ModalMessageBox";

class EventView extends React.Component {

    constructor(props){
        super(props);

        //controller instance
        this.WPCalendarEvent = new WPCalendarEvent();

        this.events_list = [];
        this.filtered_events_list= [];

        //Notifications properties
        this.setNotification=this.props.notificationHandler;  //call parent notification handler

        //STATES
        this.state = {
            events_list: [],                                    //Liste des événements  
            editform:{},                                        //modified event form  
            flag_eventinfo:false,                               //Display Info event
            flag_eventedit:false,                               //Display modif event
            flag_loadingtable:false,                           //Display loading table state (spinner)
            openModal: false,                                  //Confirmation suppression modal box 
            windowWidth: window.innerWidth,     //screen width 
            windowHeight: window.innerHeight,   //screen height

        }

        //Modal Box
        this.title = null;
        this.message = null;
        this.description = null;
        this.onConfirmCallback = null;
        this.onCancelCallback = null;

        //Table Menu
        this.MenuCell = (data) => {
            //debugger;
            return (
                <Menu>
                    <MenuButton size="small" variant="ghost" component={IconButton}>
                        <MoreHoriz /> 
                    </MenuButton>
                    <MenuList>
                        <MenuItem id={data.getValue()} onClick={()=>{this.onViewTableClick(data.getValue())}} icon={<Visibility />}>
                        Voir plus
                        </MenuItem>
                        <MenuItem id={data.getValue()} onClick={()=>{this.onEditTableClick(data.getValue())}} icon={<Edit />}>
                        Modifier
                        </MenuItem>
                        <MenuItem id={data.getValue()} onClick={()=>{this.onDeleteTableClick(data.getValue())}} icon={<Delete />}>
                        Supprimer
                        </MenuItem>
                    </MenuList>
                </Menu>
            );
        };

        //Table Header
        this.TableColumns = [ 
            { header: "Début évenement", accessorKey: "start_date", width: 170 },
            { header: "Fin évenement", accessorKey: "end_date", width: 170 },
            { header: "Titre", accessorKey: "title", width: 150 },
            { header: "Journée entière", accessorKey: "all_day", width: 120 },
            { header: "Statut", accessorKey: "status", width: 100 },
            { header: "Date publication", accessorKey: "date", width: 170 },
            { header:"", accessorKey:"id", cell: this.MenuCell, width: 70 }
        ];


    }

    /*Handle screen size*/
    handleResize = (e) => {
        this.setState({ 
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    
        };

    componentDidMount=async()=> {

        //Manage screen size
        window.addEventListener("resize", this.handleResize);

        //Retrieve List of calendar events
        this.getCalendarEvents();

        //Listener Close Edit Event form
        eventBus.on ("event_editform_close", (data) => {
             //Retrieve List of calendar events
            this.setState({events_list:[]});
            this.getCalendarEvents();

            this.setState({flag_eventedit:false});
            this.setState({flag_eventinfo:false});
            
            this.setNotification(true,{
                notifVariant: "success",
                notifMessage:"Evénement modifié avec succès",
                notifDescription: null
              });

        });

        //Listener Close INFO Event view
        eventBus.on ("event_infoview_close", (data) => {

            this.setState({flag_eventedit:false});
            this.setState({flag_eventinfo:false});

        });

        

    }

    

    /*
    RENDERING
    */
    render(){
        return(
            <Container style={{height:this.state.windowHeight-150, paddingTop:'10px'}}>
                


                {/* HANDLE MODAL BOX */}
            
                <ModalMessageBox 
                    title={this.title}
                    message={this.message}
                    description={this.description}
                    open={this.state.openModal}
                    onConfirmCallback={this.onConfirmCallback}
                    onCancelCallback={this.onCancelCallback}

                />

                {/* DATATABLE DISPLAY */}
                {!this.state.flag_eventinfo && !this.state.flag_eventedit && !this.state.flag_loadingtable &&
                    <div>
                        {/* BROWSER MODE */}
                        <BrowserView>
                            <TableComponent columns={this.TableColumns} data={this.state.events_list} />
                        </BrowserView>
                        {/* MOBILE MODE */}
                        <MobileView>
                            <Container until='xl'>
                                <Input style={{width:'150px'}} placeholder="Rechercher" onChange={this.handleChangeSearch}/>
                            </Container>
                            <Container until='xl'>
                                <Flex wrap justify='left' spacing='2-x'>
                                    {this.state.events_list.map((key, i)=>(
                                        <Card
                                            style={{width:'300px', height:'200px'}}
                                            key={'card-'+key.id} 
                                            translate 
                                        >
                                            <CardActionArea onClick={()=>{this.onViewTableClick(key.id)}}>
                                                <CardHeader
                                                    title={key.title}
                                                    key = {'header-'+key.id}
                                                />
                                                <CardContent>
                                                    <p>
                                                        <b>Début: </b>{key.start_date}
                                                    </p>
                                                    <p>
                                                        <b>Fin: </b>{key.end_date}
                                                    </p>
                                                    <p>
                                                        <b>Statut: </b>{key.status}
                                                    </p>
                                                </CardContent>
                                            </CardActionArea>
                                            <CardActions>
                                                <Chip
                                                    label=""
                                                    icon={<Edit />}
                                                    clickable
                                                    variant={"warning"}
                                                    onClick={() =>{this.onEditTableClick(key.id)}}
                                                />

                                                <Chip
                                                    label=""
                                                    icon={<Delete />}
                                                    clickable
                                                    variant={"error"}
                                                    onClick={() =>{this.onDeleteTableClick(key.id)}}
                                                />
                                            </CardActions>

                                        </Card>
                                    ))}
                                </Flex>
                            </Container>
                        </MobileView>
                    </div>
                }

                {/* DATATABLE LOADING */}
                {this.state.flag_loadingtable === true &&
                    <Flex justify="left">
                        <Spinner dots/>
                    </Flex>
                }

                {/* EVENT EDIT */}
                {this.state.flag_eventedit && !this.state.flag_eventinfo &&
                    <EventEditForm  id={this.state.editform.id}
                                    title={this.state.editform.title}
                                    start_date={this.state.editform.start_date}
                                    end_date={this.state.editform.end_date}
                                    date={this.state.editform.date}
                                    description={this.state.editform.description}
                                    allDay={this.state.editform.all_day}
                                    venue={this.state.editform.venue}
                                    notificationHandler={this.setNotification}

                    />
                }

                {/* EVENT INFO */}
                {this.state.flag_eventinfo &&
                    <EventInfoView  id={this.state.editform.id}
                    title={this.state.editform.title}
                    start_date={this.state.editform.start_date}
                    end_date={this.state.editform.end_date}
                    date={this.state.editform.date}
                    description={this.state.editform.description}
                    allDay={this.state.editform.all_day}
                    venue={this.state.editform.venue}

                    />
                }

            </Container>
        );
    }


    


    /**
     * FUNCTIONS
     */
    //Retourne la liste des événements et des lieux
    getCalendarEvents = async()=>{

        //Connect to WordPress
        this.setState({flag_loadingtable:true});    //fire loading spinner
        let response = await this.WPCalendarEvent.getCalendarEvents();
           
        
        //Authenticate error ?
        if(GlobalWPUser.user_error.status){

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage:  GlobalWPUser.user_error.status + ": "+GlobalWPUser.user_error.code,
                notifDescription: GlobalWPUser.user_error.message
              });

            this.setState({events_list:[]});
        }

        //API CALL Error ?
        else if (response === undefined || response === null){

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage:"Erreur lors de la récupération des événements",
                notifDescription: null
              });

            this.setState({events_list:[]});
        }

        else if(this.WPCalendarEvent.WPCalendarError.status !== null) {
            //API call failed
            this.setNotification(true,{
                notifVariant: "error",
                notifMessage:"Erreur lors de la récupération de l'événement",
                notifDescription: this.WPCalendarEvent.WPCalendarError.status+": "+this.WPCalendarEvent.WPCalendarError.message
              });

            this.setState({events_list:[]});
        }
        else{
            //Set response to attributes
            this.events_list = response;
            this.filtered_events_list = response;
            
            //ALL is OK close loading spinner
            this.setState({events_list: response}, this.setState({flag_loadingtable:false}));
            console.log(response);
        }
        
        

                        

    }


    //Handle on change search input box
    handleChangeSearch=(event) =>{
        const value = event.target.value;
        debugger
        //Filter Data Table
        let _ = require('underscore');
        let filtered_data = _.filter(this.events_list,function(item){

            let found=false;
            Object.keys(item).forEach(function(key) {
                
                if (item[key] === undefined || typeof item[key]=== 'object'){
                    /*skip undefined keys*/
                }
                
                else if(!isNaN(item[key]) || !isNaN(value) ){
                    
                    
                    if(item[key].toString().includes(value.toString())===true){
                        found = true;

                    }
                }
                else if(item[key].toLowerCase().includes(value.toLowerCase())===true){
                    found = true;
                }
                
            });
            return found === true;

        });

        this.filtered_events_list=filtered_data; //update filtered data    

        if (this.filtered_events_list.length > 0){
            this.setState({events_list: filtered_data})
        }else{
            this.setState({events_list: []})
        }


        
    }


    /**
     * EVENTS
     */


    //On click "modifier"
    onEditTableClick = async (selectedId) => {
        
        //let selectedId =  e.target.closest("li").id; //get selected contact

        this.setState({flag_loadingtable:true})

        //retrieve event information
        let eventData = await this.WPCalendarEvent.getCalendarEventsByID(selectedId);
        let formData = eventData;

        //Fire Edition form by changing state
        this.setState({editform:formData})
        this.setState({flag_eventinfo:false});
        this.setState({flag_eventedit:true, flag_loadingtable:false});

  
    }

    //On click "voir plus"
    onViewTableClick = async (selectedId) => {
        //debugger;
        //let selectedId =  e.target.closest("li").id; //get selected contact

        this.setState({flag_loadingtable:true})

        //retrieve event information
        let eventData = await this.WPCalendarEvent.getCalendarEventsByID(selectedId);
        let formData = eventData;

        //Fire Edition form by changing state
        this.setState({editform:formData})
        this.setState({flag_eventedit:false});
        this.setState({flag_eventinfo:true, flag_loadingtable:false});
        

  
    }



     //On click "delete"
     onDeleteTableClick = async (selectedId) => {
    
      this.title="Suppression";
      this.message="Confirmez-vous la suppression de l'événement?";
      this.description=null;
      this.onConfirmCallback=this.onDeleteTableConfirm.bind(this, selectedId);
      this.onCancelCallback=()=>{this.setState({openModal:false})}
      this.setState({openModal:true});
        


    }

    /**
     * On user confirm event deletion
     * @param {number} selectedId selected event id
     * @returns 
     */
    onDeleteTableConfirm = async (selectedId)=>{
        //let selectedId =  e.target.closest("li").id;
        let response = await this.WPCalendarEvent.deleteCalendarEvent(selectedId);

        //Authenticate error ?
        if(GlobalWPUser.user_error.status){

            this.setState({ openModal: false});

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: GlobalWPUser.user_error.status + ": "+GlobalWPUser.user_error.code,
                notifDescription: GlobalWPUser.user_error.message
              });

        }
        else if (response===undefined || response===null || !response.id){

            this.setState({openModal: false});

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: "Erreur lors de la Suppression de l'événement",
                notifDescription: null
              });

            return; //no need to refresh event list
        }
        else if(this.WPCalendarEvent.WPCalendarError.status !== null) {
            //API call failed
            this.setState({openModal: false});

            this.setNotification(true,{
                notifVariant: "error",
                notifMessage: this.WPCalendarEvent.WPCalendarError.status+": "+this.WPCalendarEvent.WPCalendarError.message,
                notifDescription: null
              });

            this.setState({events_list:[]});
        }
        
        else{
            //All is pl
            this.setState({openModal: false});

            this.setNotification(true,{
                notifVariant: "success",
                notifMessage: "Evénement "+response.title+" a bien été supprimé",
                notifDescription: null
              });

            this.getCalendarEvents();
        }


    }


}

export default EventView;